"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_1 = require("react");

var popmotion_pose_1 = require("popmotion-pose");

var reactLifecyclePolyfill = require("react-lifecycles-compat");

exports.PoseParentContext = react_1.createContext({});

var calcPopFromFlowStyle = function calcPopFromFlowStyle(el) {
  var offsetTop = el.offsetTop,
      offsetLeft = el.offsetLeft,
      offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  return {
    position: 'absolute',
    top: offsetTop,
    left: offsetLeft,
    width: offsetWidth,
    height: offsetHeight
  };
};

var hasPose = function hasPose(pose, key) {
  return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
};

var objectToMap = function objectToMap(obj) {
  return Object.keys(obj).reduce(function (map, key) {
    map.set(key, obj[key]);
    return map;
  }, new Map());
};

var PoseElement = function (_super) {
  __extends(PoseElement, _super);

  function PoseElement() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.children = new Set();
    _this.childrenHandlers = {
      registerChild: function registerChild(props) {
        _this.children.add(props);

        if (_this.poser) _this.flushChildren();
      },
      onUnmount: function onUnmount(child) {
        return _this.poser.removeChild(child);
      },
      getParentPoseProps: function getParentPoseProps() {
        return _this.props.poseProps;
      },
      getInitialPoseFromParent: function getInitialPoseFromParent() {
        return _this.getInitialPose();
      }
    };

    _this.getRefs = function () {
      var refs = {};
      var elementType = _this.props.elementType;

      if (typeof elementType === 'string') {
        refs.ref = _this.setRef;
      } else {
        refs.innerRef = _this.setRef;
        refs.hostRef = _this.setRef;
      }

      return refs;
    };

    _this.setRef = function (ref) {
      if (ref instanceof Element || _this.ref && ref === null) {
        var innerRef = _this.props.innerRef;
        if (innerRef) innerRef(ref);
        _this.ref = ref;
      }
    };

    return _this;
  }

  PoseElement.prototype.getInitialPose = function () {
    var _a = this.props,
        getInitialPoseFromParent = _a.getInitialPoseFromParent,
        pose = _a.pose,
        initialPose = _a.initialPose;

    if (initialPose) {
      return initialPose;
    } else {
      var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
      var thisPose = Array.isArray(pose) ? pose : [pose];
      return Array.isArray(parentPose) ? parentPose.concat(thisPose) : [parentPose].concat(thisPose);
    }
  };

  PoseElement.prototype.getFirstPose = function () {
    var pose = this.props.pose;
    return pose && pose !== this.getInitialPose() ? pose : undefined;
  };

  PoseElement.prototype.getSetProps = function () {
    var _a = this.props,
        children = _a.children,
        elementType = _a.elementType,
        poseProps = _a.poseProps,
        onChange = _a.onChange,
        onValueChange = _a.onValueChange,
        innerRef = _a.innerRef,
        pose = _a.pose,
        initialPose = _a.initialPose,
        onPoseComplete = _a.onPoseComplete,
        getParentPoseProps = _a.getParentPoseProps,
        registerChild = _a.registerChild,
        onUnmount = _a.onUnmount,
        getInitialPoseFromParent = _a.getInitialPoseFromParent,
        popFromFlow = _a.popFromFlow,
        values = _a.values,
        parentValues = _a.parentValues,
        onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd,
        props = __rest(_a, ["children", "elementType", "poseProps", "onChange", "onValueChange", "innerRef", "pose", "initialPose", "onPoseComplete", "getParentPoseProps", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd"]);

    if (popFromFlow && this.ref && this.ref instanceof HTMLElement) {
      if (!this.popStyle) {
        props.style = __assign({}, props.style, calcPopFromFlowStyle(this.ref));
        this.popStyle = props.style;
      } else {
        props.style = this.popStyle;
      }
    } else {
      this.popStyle = null;
    }

    if (typeof onChange === 'function') props.onChange = onChange;
    return props;
  };

  PoseElement.prototype.componentDidMount = function () {
    var _this = this;

    if (!this.ref) return;
    var _a = this.props,
        poseProps = _a.poseProps,
        onChange = _a.onChange,
        onValueChange = _a.onValueChange,
        registerChild = _a.registerChild,
        values = _a.values,
        parentValues = _a.parentValues,
        onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd;

    var props = __assign({}, poseProps, {
      initialPose: this.getInitialPose(),
      values: values || poseProps.values,
      parentValues: parentValues ? objectToMap(parentValues) : parentValues,
      transitionProps: this.getSetProps(),
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      onChange: onValueChange ? onValueChange : typeof onChange !== 'function' ? onChange : undefined
    });

    if (!registerChild) {
      this.initPoser(popmotion_pose_1.default(this.ref, props));
    } else {
      registerChild({
        element: this.ref,
        poserProps: props,
        onRegistered: function onRegistered(poser) {
          return _this.initPoser(poser);
        }
      });
    }
  };

  PoseElement.prototype.UNSAFE_componentWillUpdate = function (_a) {
    var pose = _a.pose;
    if (hasPose(pose, 'flip')) this.poser.measure();
  };

  PoseElement.prototype.componentDidUpdate = function (prevProps) {
    var pose = this.props.pose;
    this.poser.setTransitionProps(this.getSetProps());
    if (pose !== prevProps.pose || pose === 'flip') this.setPose(pose);
  };

  PoseElement.prototype.componentWillUnmount = function () {
    if (!this.poser) return;
    var onUnmount = this.props.onUnmount;
    if (onUnmount) onUnmount(this.poser);
    this.poser.destroy();
  };

  PoseElement.prototype.initPoser = function (poser) {
    this.poser = poser;
    this.flushChildren();
    var firstPose = this.getFirstPose();
    if (firstPose) this.setPose(firstPose);
  };

  PoseElement.prototype.setPose = function (pose) {
    var _this = this;

    var onPoseComplete = this.props.onPoseComplete;
    var poseList = Array.isArray(pose) ? pose : [pose];
    Promise.all(poseList.map(function (key) {
      return key && _this.poser.set(key);
    })).then(function () {
      return onPoseComplete && onPoseComplete();
    });
  };

  PoseElement.prototype.flushChildren = function () {
    var _this = this;

    this.children.forEach(function (_a) {
      var element = _a.element,
          poserProps = _a.poserProps,
          onRegistered = _a.onRegistered;
      return onRegistered(_this.poser.addChild(element, poserProps));
    });
    this.children.clear();
  };

  PoseElement.prototype.render = function () {
    var _a = this.props,
        elementType = _a.elementType,
        children = _a.children;
    return React.createElement(exports.PoseParentContext.Provider, {
      value: this.childrenHandlers
    }, react_1.createElement(elementType, __assign({}, this.getSetProps(), this.getRefs()), children));
  };

  return PoseElement;
}(React.PureComponent);

exports.PoseElement = PoseElement;
reactLifecyclePolyfill(PoseElement);